(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6869],{

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(6856)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadable = _interop_require_default(__webpack_require__(4302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 6319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(9658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadableContext = __webpack_require__(6319);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(1688)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 1229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z3": function() { return /* binding */ FormModalFieldBox; },
  "LW": function() { return /* binding */ FormModalFieldLabel; },
  "Av": function() { return /* binding */ FormModalFieldName; },
  "_p": function() { return /* binding */ FormModalFormComponent; },
  "uR": function() { return /* binding */ FormModalSelect; },
  "n5": function() { return /* binding */ FormModalSelectInput; },
  "zm": function() { return /* binding */ FormModalSelectLabel; },
  "cc": function() { return /* binding */ FormModalSelectMenu; },
  "Wg": function() { return /* binding */ FormModalSelectOptions; },
  "nH": function() { return /* binding */ FormModalSelectText; },
  "TB": function() { return /* binding */ FormModalSubmitButton; },
  "zN": function() { return /* binding */ FormModalSuccessMessage; },
  "Mm": function() { return /* binding */ FormModalSuccessMessageContainer; },
  "qV": function() { return /* binding */ FormModalTextArea; },
  "d3": function() { return /* binding */ FormModalTextInput; }
});

// UNUSED EXPORTS: FormModalOption, default

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/utils/className.ts
var utils_className = __webpack_require__(9659);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/Institutional/AdvertiseHere/FormModal/styles.tsx







var variants = {
    FormModalSelectMenu: {
        isOpen: {
            true: "border-b-0 rounded-b-none cursor-default relative",
            false: ""
        }
    },
    FormModalSelectOptions: {
        isOpen: {
            true: "bg-mglGray50 w-full block visible max-h-[148px] overflow-y-scroll",
            false: "invisible hidden"
        }
    },
    FormModalSuccessMessage: {
        title: {
            true: "text-2xl font-medium mb-2",
            false: ""
        }
    }
};
var FormModalFormComponent = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "mx-auto my-0 flex max-w-[83.33%] flex-col gap-y-6"
    }, rest), {
        children: children
    }));
};
var FormModalFieldBox = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex w-full flex-col gap-y-2"
    }, rest), {
        children: children
    }));
};
var FormModalFieldName = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex items-center gap-x-4"
    }, rest), {
        children: children
    }));
};
var FormModalFieldLabel = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "text-xs text-mglGray900"
    }, rest), {
        children: children
    }));
};
var FormModalTextInput = function(_param) {
    var rest = _extends({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
        className: "w-full rounded border border-solid border-mglGray200 bg-mglGray50 p-3 text-[0.625rem] text-mglGray900 transition-all duration-300 ease-ease focus:border focus:border-solid focus:border-mglBlue400"
    }, rest));
};
var FormModalTextArea = function(_param) {
    var rest = _extends({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread/* default */.Z)({
        className: "min-h-[100px] w-full rounded border border-solid border-mglGray200 bg-mglGray50 p-3 text-[0.625rem] text-mglGray900 transition-all duration-300 ease-ease focus:border focus:border-solid focus:border-mglBlue400"
    }, rest));
};
var FormModalSelect = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        className: "relative"
    }, rest), {
        children: children
    }));
});
var FormModalSelectText = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "text-[0.625rem] text-mglGray900"
    }, rest), {
        children: children
    }));
};
var FormModalSelectMenu = function(_param) {
    var children = _param.children, isOpen = _param.isOpen, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "isOpen"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils_className/* default */.Z)('relative w-full cursor-pointer appearance-none rounded border border-solid border-mglGray200 bg-mglGray50 bg-[url("data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3Ctitle%3Edown-arrow%3C%2Ftitle%3E%3Cg%20fill%3D%22%23000000%22%3E%3Cpath%20d%3D%22M10.293%2C3.293%2C6%2C7.586%2C1.707%2C3.293A1%2C1%2C0%2C0%2C0%2C.293%2C4.707l5%2C5a1%2C1%2C0%2C0%2C0%2C1.414%2C0l5-5a1%2C1%2C0%2C1%2C0-1.414-1.414Z%22%20fill%3D%22%23000000%22%3E%3C%2Fpath%3E%3C%2Fg%3E%3C%2Fsvg%3E")] bg-[length:0.6em] bg-[calc(100%-1.3em)_center] bg-no-repeat p-3 focus:border-mglBlue400', isOpen != undefined && variants.FormModalSelectMenu.isOpen[isOpen.toString()])
    }, rest), {
        children: children
    }));
};
var FormModalSelectOptions = function(_param) {
    var children = _param.children, isOpen = _param.isOpen, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "isOpen"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils_className/* default */.Z)("absolute z-[1] border border-t-0 border-solid border-mglGray200 transition-all duration-75 ease-ease", isOpen != undefined && variants.FormModalSelectOptions.isOpen[isOpen.toString()])
    }, rest), {
        children: children
    }));
};
var FormModalSelectInput = function(_param) {
    var rest = _extends({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
        className: "hidden"
    }, rest));
};
var FormModalSelectLabel = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("label", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "block cursor-pointer p-2 text-[0.625rem] transition-all duration-300 ease-ease hover:bg-mglBlue400 hover:text-mglGray50 focus:bg-mglBlue400 focus:text-mglGray50"
    }, rest), {
        children: children
    }));
};
var FormModalOption = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "w-full bg-mglGray50 p-2 text-[0.625rem] text-mglGray900 transition-all duration-300 ease-ease hover:border hover:border-solid hover:border-mglBlue400"
    }, rest), {
        children: children
    }));
};
var FormModalSubmitButton = function(_param) {
    var children = _param.children, _className = _param.className, className = _className === void 0 ? "" : _className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils_className/* default */.Z)("max-w-80 rounded-[60px] border-none [background:0] [&>div>div>span]:text-base [&>div>div>span]:leading-4 [&>div>div]:me-[auto] [&>div>div]:ms-[auto] [&>div>span>svg]:disabled:hidden [&>div]:flex [&>div]:border-black/10 [&>div]:px-6 hover:[&>div]:bg-mglGray900 hover:[&>div]:text-mglGray50 [&>div]:disabled:opacity-40 [&>div]:disabled:hover:cursor-default [&>div]:disabled:hover:border [&>div]:disabled:hover:border-solid [&>div]:disabled:hover:border-black/5 [&>div]:disabled:hover:bg-mglGray50 [&>div]:disabled:hover:text-mglGray900 [&>span]:m-0", className)
    }, rest), {
        children: children
    }));
};
var FormModalSuccessMessageContainer = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex flex-col items-center justify-center"
    }, rest), {
        children: children
    }));
};
var FormModalSuccessMessage = function(_param) {
    var children = _param.children, isTitle = _param.isTitle, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "isTitle"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,utils_className/* default */.Z)("text-base text-mglGray900", isTitle != undefined && variants.FormModalSuccessMessage[isTitle.toString()])
    }, rest), {
        children: children
    }));
};
/* harmony default export */ var styles = ({
    FormModalFieldBox: FormModalFieldBox,
    FormModalFieldName: FormModalFieldName,
    FormModalFieldLabel: FormModalFieldLabel,
    FormModalFormComponent: FormModalFormComponent,
    FormModalTextInput: FormModalTextInput,
    FormModalTextArea: FormModalTextArea,
    FormModalSelect: FormModalSelect,
    FormModalSelectText: FormModalSelectText,
    FormModalSelectMenu: FormModalSelectMenu,
    FormModalSelectOptions: FormModalSelectOptions,
    FormModalSelectInput: FormModalSelectInput,
    FormModalSelectLabel: FormModalSelectLabel,
    FormModalOption: FormModalOption,
    FormModalSubmitButton: FormModalSubmitButton
});


/***/ }),

/***/ 7517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/Layout/Breadcrumb/styles.tsx




var BreadcrumbItemContainer = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex flex-row items-center font-light text-mglGray500 before:mr-2 before:flex before:h-[13px] before:w-2 before:items-center before:justify-center before:pb-[3px] before:text-center before:text-base before:leading-none before:content-['›'] first-of-type:before:content-none"
    }, props), {
        children: props.children
    }));
};
var BreadcrumbItem = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "flex h-4 flex-row items-center text-xs leading-4 text-mglGray500 no-underline"
    }, props), {
        ref: ref,
        children: props.children
    }));
});


// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
;// CONCATENATED MODULE: ./src/components/Layout/Breadcrumb/index.tsx
/* eslint-disable react/no-array-index-key */ 





var publicRuntimeConfig = config_default()().publicRuntimeConfig;
function Breadcrumb(param) {
    var breadcrumbList = param.breadcrumbList, _isSubDomain = param.isSubDomain, isSubDomain = _isSubDomain === void 0 ? false : _isSubDomain;
    var ref;
    var currentSpan = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getSpan();
    var breadcrumbSpan = currentSpan && currentSpan.startChild({
        op: "breadcrumb"
    });
    var workingList = (0,_to_consumable_array/* default */.Z)(breadcrumbList).filter(function(item) {
        return item.url !== "/";
    });
    workingList.unshift({
        titulo: "Home",
        url: "/"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "place-content-[center_start] mb-2 flex flex-wrap items-center gap-2",
        children: [
            workingList.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItemContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: isSubDomain ? "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL).concat(item.url) : item.url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbItem, {
                            title: "Ir para ".concat(item.titulo),
                            children: item.titulo
                        })
                    })
                }, item.url);
            }),
            breadcrumbSpan && breadcrumbSpan.finish()
        ]
    });
}


/***/ }),

/***/ 2384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chip; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9659);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6008);







var variants = {
    sizes: {
        small: "h-6",
        medium: "h-9",
        large: "h-12"
    },
    backgroundColor: {
        white: "chip-bg-color [&.chip-bg-color]:bg-mglGray50",
        black: "chip-bg-color [&.chip-bg-color]:bg-mglGray900",
        green: "chip-bg-color [&.chip-bg-color]:bg-mglGreen500"
    },
    color: {
        black: "text-mglGray900",
        white: "chip-color [&.chip-color]:text-mglGray50 [&.chip-color]:[&_svg]:fill-mglGray50"
    },
    hover: {
        white: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray50 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        black: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray900 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50",
        gray: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGray200 hover:[&.chip-hover-color]:text-mglGray900 [&.chip-hover-color]:hover:[&_path]:fill-mglGray900",
        green: "chip-hover-color hover:[&.chip-hover-color]:bg-mglGreen600 hover:[&.chip-hover-color]:text-mglGray50 [&.chip-hover-color]:hover:[&_path]:fill-mglGray50"
    },
    borderColor: {
        gray: "chip-border-color [&.chip-border-color]:border-mglGray900/20 hover:[&.chip-border-color]:border-mglGray50",
        black: "border-mglGray900/20",
        white: "chip-border-color [&.chip-border-color]:border-mglGray50/20",
        green: "chip-border-color [&.chip-border-color]:border-mglGreen500 hover:[&.chip-border-color]:border-mglGreen600"
    }
};
function Chip(param) {
    var texto = param.texto, prepIcon = param.prepIcon, posIcon = param.posIcon, _link = param.link, link = _link === void 0 ? "#" : _link, _color = param.color, color = _color === void 0 ? undefined : _color, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? undefined : _backgroundColor, backgroundImage = param.backgroundImage, _overlayOpacity = param.overlayOpacity, overlayOpacity = _overlayOpacity === void 0 ? 60 : _overlayOpacity, _chipSize = param.chipSize, chipSize = _chipSize === void 0 ? "small" : _chipSize, _borderColor = param.borderColor, borderColor = _borderColor === void 0 ? undefined : _borderColor, _title = param.title, title = _title === void 0 ? "" : _title, _highlightedText = param.highlightedText, highlightedText = _highlightedText === void 0 ? "" : _highlightedText, className = param.className, onClick = param.onClick, _hover = param.hover, hover = _hover === void 0 ? undefined : _hover, _rel = param.rel, rel = _rel === void 0 ? "" : _rel, _target = param.target, target = _target === void 0 ? "_self" : _target;
    var isValidLink = link[0] !== "#" && !/^\/\//.test(link) && link !== "";
    var Container = isValidLink ? (next_link__WEBPACK_IMPORTED_MODULE_2___default()) : react__WEBPACK_IMPORTED_MODULE_1__.Fragment;
    var Tag = link !== "#" && link !== "" ? "a" : "div";
    var linkProps = {};
    if (isValidLink) {
        Object.assign(linkProps, {
            href: link,
            passHref: true,
            prefetch: false
        });
    }
    var backgroundStyle = backgroundImage ? {
        backgroundImage: "linear-gradient(rgba(0, 0, 0, ".concat(overlayOpacity / 100, "), rgba(0, 0, 0, ").concat(overlayOpacity / 100, ")), url(").concat(backgroundImage, ")"),
        backgroundSize: "cover",
        backgroundPosition: "center"
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, linkProps), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, link && link !== "#" && {
            href: link
        }), {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative flex cursor-pointer flex-row flex-nowrap items-center justify-center overflow-hidden rounded-[100px] border border-solid px-4 no-underline transition-all ease-in [&_path]:transition-colors [&_path]:ease-ease", variants.sizes[chipSize], !backgroundImage && variants.backgroundColor[backgroundColor], variants.color[color], variants.borderColor[borderColor], variants.hover[hover], backgroundImage && "text-white", className),
            style: backgroundStyle,
            rel: rel,
            title: title,
            onClick: onClick,
            target: target,
            children: [
                !!prepIcon && typeof prepIcon === "string" && (prepIcon === "chevron-down" || prepIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(prepIcon),
                        width: 16
                    })
                }) : !!prepIcon && typeof prepIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pr-1",
                    children: prepIcon
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "relative mt-[-2px] whitespace-nowrap text-center text-xs no-underline",
                            children: texto
                        }),
                        !!highlightedText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "text-base font-semibold leading-none",
                            children: highlightedText
                        })
                    ]
                }),
                !!posIcon && typeof posIcon === "string" && (posIcon === "chevron-down" || posIcon === "chevron-right") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1 [&_svg]:w-4",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: "mdi:".concat(posIcon),
                        width: 16
                    })
                }) : !!posIcon && typeof posIcon !== "string" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "relative -m-1 flex pl-1",
                    children: posIcon
                })
            ]
        }))
    }));
}


/***/ }),

/***/ 1080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


function Container(param) {
    var children = param.children, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _className = param.className, className = _className === void 0 ? "" : _className;
    var variants = {
        hasBreadcrumb: {
            true: "mt-4 desktop:mt-10",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("w-full max-w-[calc(100%-2rem)] desktop:max-w-[83.33%]", variants.hasBreadcrumb[hasBreadcrumb.toString()], className),
        children: children
    });
}


/***/ }),

/***/ 9879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Titulo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Chip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2384);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9659);



function Titulo(param) {
    var texto = param.texto, color = param.color, urlRedirect = param.urlRedirect, showChip = param.showChip, alignRight = param.alignRight, _headingTag = param.headingTag, headingTag = _headingTag === void 0 ? "h2" : _headingTag, _noPadding = param.noPadding, noPadding = _noPadding === void 0 ? false : _noPadding;
    var titleStyles = "flex items-center text-2xl text-left font-medium";
    var Heading = headingTag;
    var chipProps = {
        black: {
            color: "black",
            border: "black",
            title: "text-mglGray900",
            hover: "black"
        },
        white: {
            color: "white",
            border: "white",
            title: "text-mglGray50",
            hover: "white"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex items-center pb-2 [&>svg]:ml-[5px] [&>svg]:transition-all [&>svg]:duration-200 hover:[&>svg]:ml-[10px]", noPadding && "p-0"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(titleStyles, !alignRight && "mr-2", chipProps[color].title),
                children: texto
            }),
            alignRight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mr-auto"
            }),
            showChip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Chip__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                texto: "ver tudo",
                color: chipProps[color].color,
                chipSize: "medium",
                posIcon: "chevron-right",
                title: "ver tudo - ".concat(texto),
                borderColor: chipProps[color].border,
                link: urlRedirect,
                hover: chipProps[color].hover
            })
        ]
    });
}


/***/ }),

/***/ 3078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WrapperContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1080);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9642);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9659);




function WrapperContent(param) {
    var children = param.children, backgroundColor = param.backgroundColor, _isOnHeader = param.isOnHeader, isOnHeader = _isOnHeader === void 0 ? false : _isOnHeader, _paddingOnBottom = param.paddingOnBottom, paddingOnBottom = _paddingOnBottom === void 0 ? false : _paddingOnBottom, _paddingOnTop = param.paddingOnTop, paddingOnTop = _paddingOnTop === void 0 ? false : _paddingOnTop, _hasBreadcrumb = param.hasBreadcrumb, hasBreadcrumb = _hasBreadcrumb === void 0 ? false : _hasBreadcrumb, _mobileOnly = param.mobileOnly, mobileOnly = _mobileOnly === void 0 ? false : _mobileOnly, _desktopOnly = param.desktopOnly, desktopOnly = _desktopOnly === void 0 ? false : _desktopOnly, _className = param.className, className = _className === void 0 ? undefined : _className;
    var variants = {
        isOnHeader: {
            true: "isOnHeader [&.isOnHeader]:p-0",
            false: ""
        },
        paddingOnBottom: {
            true: "paddingOnBottom [&.paddingOnBottom]:pb-10",
            false: "pb-0"
        },
        paddingOnTop: {
            true: "paddingOnTop [&.paddingOnTop]:pt-10",
            false: ""
        },
        mobileOnly: {
            true: "flex desktop:hidden",
            false: ""
        },
        desktopOnly: {
            true: "hidden desktop:flex",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: {
            backgroundColor: backgroundColor || _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_2__/* .mglGray.mglGray50 */ .Ce.mglGray50
        },
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative flex w-full flex-col flex-wrap content-center justify-center px-0 py-10", variants.isOnHeader[isOnHeader.toString()], variants.paddingOnBottom[paddingOnBottom.toString()], variants.paddingOnTop[paddingOnTop.toString()], variants.mobileOnly[mobileOnly.toString()], variants.desktopOnly[desktopOnly.toString()]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            hasBreadcrumb: hasBreadcrumb,
            className: className,
            children: children
        })
    });
}


/***/ }),

/***/ 804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var PageDataContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
/* harmony default export */ __webpack_exports__["Z"] = (PageDataContext);


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(638)


/***/ }),

/***/ 3250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(7294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 1688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3250);
} else {}


/***/ }),

/***/ 2222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};


/***/ })

}]);